/**
 * import中的webpackChunkName，为按需加载生成的JS名称，请使用 [project-name]-[module-name]，示例如下
 */
export default [{
  path: '*',
  component: () =>
    import ( /* webpackChunkName: "example-NotFound" */ '../views/errorPages/not-found')
}]